var map = {
	"./banner.png": 4612,
	"./charts.png": 9013,
	"./emoji-crown.png": 6552,
	"./emoji-en.png": 7156,
	"./emoji-gallery.png": 3843,
	"./emoji-gift-bags.png": 6683,
	"./emoji-grinning-cat.png": 114,
	"./emoji-highRise.png": 1114,
	"./emoji-key.png": 9372,
	"./emoji-man.png": 829,
	"./emoji-papers.png": 2984,
	"./emoji-picture.png": 7695,
	"./emoji-ru.png": 1514,
	"./emoji-ruller.png": 9179,
	"./emoji-sad-cat.png": 3550,
	"./emoji-settings.png": 1218,
	"./emoji-smiling-cat-with-heart-eyes.png": 1262,
	"./emoji-videocamera.png": 8561,
	"./emoji-weary-cat.png": 5656,
	"./emoji-women.png": 5839,
	"./new-banners.png": 8736,
	"./roket-icon.png": 5053,
	"./smallCapture.png": 8443,
	"./suggestion-banner.png": 755,
	"./tilda.png": 9534
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3609;